import { Injectable } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({
  providedIn: 'root',
})
export class VayAntService {
  constructor(private message: NzMessageService) {}

  showMessage(message: string, type = 'success'): void {
    // success  error warning
    this.message.create(type, message);
  }

  shwModal(title: string, content = '', type: any) {}
}
